<template lang="pug">
  v-container(fill-height fluid)
    div.main-container-spliter
      v-slide-y-transition
        div(v-if="!showSideNav").main-container-spliter-open-arrow
            a(href="javascript:void(0);" @click.stop="toggleSideNav")
                img(
                  :src="openButton()"
                  width="30px"
                  alt="Open"
                )
    v-layout(row justify-center)
      v-flex(xs2 v-if="!singleView && !wideNav")
        slot(name="left-content")
      v-flex(xs10 v-if="!singleView && !wideNav")
        slot(name="right-content")
      v-flex(xs4 v-if="!singleView && wideNav")
        slot(name="left-content")
      v-flex(xs8 v-if="!singleView && wideNav")
        slot(name="right-content")
      v-flex(xs12 v-if="singleView" id="right-content")
        slot(name="content")
</template>

<script>
import * as types from '@/store/mutationTypes';
import { mapState } from 'vuex';

export default {
    name: 'AppPage',

    props: {
        singleView: { type: Boolean, required: false, default: false },
        wideNav: { type: Boolean, required: false, default: false }
    },
    data() {
        return {
            loading: false
        };
    },
    computed: {
        ...mapState({
            cursor: state => state.appearance.cursor,
        }),
        showSideNav: {
            get() {
                return this.$store.state.appearance.showSideNav;
            },

            set(value) {
                this.$store.commit(types.APPEARANCE_SET_SIDE_NAV, value);
            }
        },
    },
    watch: {
        cursor(value) {
            switch (value) {
                case 'progress':
                    this.loading = true;
                    break;
                default:
                    this.loading = false;
                    break;
            }
        }
    },
    methods: {
        openButton() {
            return this.remapColors('data:image/svg+xml,%3Csvg%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%20xmlns%3Axlink%3D%22http%3A%2F%2Fwww.w3.org%2F1999%2Fxlink%22%20viewBox%3D%22-1%202.926%2086.832%20280.535%22%20width%3D%2283%22%20height%3D%22277%22%3E%3Cdefs%3E%3Cpath%20d%3D%22M8.65%208.9l5.07%203.28%204.93%203.48%204.79%203.66%204.65%203.83%204.49%204.01%204.33%204.18%204.18%204.34%204%204.49%203.83%204.65%203.66%204.79%203.47%204.94%203.29%205.07%203.09%205.21%202.9%205.33%202.69%205.45%202.49%205.57%202.27%205.68%202.06%205.79%201.83%205.89%201.6%205.99%201.38%206.08%201.13%206.16.89%206.25.64%206.32.39%206.39.13%206.46-.13%206.46-.39%206.4-.64%206.32-.89%206.24-1.13%206.17-1.38%206.08-1.6%205.98-1.83%205.89-2.06%205.79-2.27%205.68-2.49%205.57-2.69%205.46-2.9%205.33-3.09%205.21-3.29%205.07-3.47%204.93-3.66%204.8-3.83%204.65-4%204.49-4.18%204.34-4.33%204.17-4.49%204.01-4.65%203.84-4.79%203.66-4.93%203.47-5.07%203.29-5.2%203.1L0%20280.46V3.93L3.45%205.8l5.2%203.1z%22%20id%3D%22open-a%22%2F%3E%3Cpath%20d%3D%22M16.93%20111.02c.26.8%205.42%208.73%2011.64%2017.86%206.48%209.26%2010.98%2017.19%2010.58%2018.25-.4%201.06-5.29%208.86-11.11%2017.46-5.69%208.59-10.71%2016.26-11.24%2017.06-.4.79.79%203.83%202.91%206.88.23.36%201.42%202.16%203.57%205.42l16.13-23.68%2016.14-23.8c-9.52-14.29-14.81-22.22-15.87-23.81-8.73-13.09-16.01-23.81-16.27-23.81-.13%200-1.72%202.39-3.57%205.43-1.85%202.91-3.18%205.95-2.91%206.74z%22%20id%3D%22open-c%22%2F%3E%3C%2Fdefs%3E%3Cuse%20xlink%3Ahref%3D%22%23open-a%22%20fill%3D%22%23fff%22%2F%3E%3Cuse%20xlink%3Ahref%3D%22%23open-a%22%20fill-opacity%3D%220%22%20stroke%3D%22%230928f8%22%20stroke-width%3D%220%22%2F%3E%3Cfilter%20id%3D%22open-b%22%20x%3D%22-9%22%20y%3D%22-5.07%22%20width%3D%22101.83%22%20height%3D%22295.54%22%20filterUnits%3D%22userSpaceOnUse%22%3E%3CfeFlood%2F%3E%3CfeComposite%20in2%3D%22SourceAlpha%22%20operator%3D%22out%22%2F%3E%3CfeGaussianBlur%20stdDeviation%3D%221%22%2F%3E%3CfeOffset%20dx%3D%221%22%20dy%3D%221%22%20result%3D%22afterOffset%22%2F%3E%3CfeFlood%20flood-color%3D%22%23fff%22%20flood-opacity%3D%22.8%22%2F%3E%3CfeComposite%20in2%3D%22afterOffset%22%20operator%3D%22in%22%2F%3E%3CfeMorphology%20operator%3D%22dilate%22%20radius%3D%221%22%2F%3E%3CfeComposite%20in2%3D%22SourceAlpha%22%20operator%3D%22in%22%2F%3E%3C%2Ffilter%3E%3Cpath%20d%3D%22M8.65%208.9l5.07%203.28%204.93%203.48%204.79%203.66%204.65%203.83%204.49%204.01%204.33%204.18%204.18%204.34%204%204.49%203.83%204.65%203.66%204.79%203.47%204.94%203.29%205.07%203.09%205.21%202.9%205.33%202.69%205.45%202.49%205.57%202.27%205.68%202.06%205.79%201.83%205.89%201.6%205.99%201.38%206.08%201.13%206.16.89%206.25.64%206.32.39%206.39.13%206.46-.13%206.46-.39%206.4-.64%206.32-.89%206.24-1.13%206.17-1.38%206.08-1.6%205.98-1.83%205.89-2.06%205.79-2.27%205.68-2.49%205.57-2.69%205.46-2.9%205.33-3.09%205.21-3.29%205.07-3.47%204.93-3.66%204.8-3.83%204.65-4%204.49-4.18%204.34-4.33%204.17-4.49%204.01-4.65%203.84-4.79%203.66-4.93%203.47-5.07%203.29-5.2%203.1L0%20280.46V3.93L3.45%205.8l5.2%203.1z%22%20fill%3D%22%23fff%22%20filter%3D%22url%28%23open-b%29%22%2F%3E%3Cg%3E%3Cuse%20xlink%3Ahref%3D%22%23open-c%22%20fill%3D%22%23ff6600%22%2F%3E%3Cuse%20xlink%3Ahref%3D%22%23open-c%22%20fill-opacity%3D%220%22%20stroke%3D%22%23ff6600%22%2F%3E%3C%2Fg%3E%3C%2Fsvg%3E');
        },
        toggleSideNav() {
            this.$store.commit(types.APPEARANCE_TOGGLE_SIDE_NAV);
        }
    }
};

</script>

<style>
#right-content>.v-card {
  box-shadow: none;
}

.main-container-spliter-open-arrow{
    top: 74px;
    position: relative;
}

.main-container-spliter {
    height: 100%;
    position: relative;
    float: left;
    left: -24px;
    width: 1px;
    z-index: 1;
}

@media (max-width:1024px){
  .main-container-spliter {
    left: -10px;
  }
}

@media (max-width:768px){
  .main-container-spliter {
    left: -10px;
  }
}

@media (max-width:414px){
  .main-container-spliter {
    left: -10px;
  }
}

@media (max-width:375px){
  .main-container-spliter {
    left: -14px;
  }
}

@media (max-width:320px){
  .main-container-spliter {
    left: -20px;
  }
}

</style>



// WEBPACK FOOTER //
// src/components/core/AppPage.vue